import { Outlet } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileStickyBar } from "@/components/MobileStickyBar";
import { QuoteModal } from "@/components/QuoteModal";
import { ScrollToTop } from "@/components/ScrollToTop";

export const Layout = ({ renderedYear }) => {
  const { t } = useLanguage();
  return (
  <div className="min-h-screen flex flex-col bg-[#FAFCFF]">
    <ScrollToTop />
    <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-white focus:p-3 focus:text-slate-950">{t("Skip to main content")}</a>
    <Header />
    {/* Bottom padding on mobile so the sticky bar never covers content */}
    <main id="main-content" tabIndex={-1} className="flex-1 pb-24 md:pb-0">
      <Outlet />
    </main>
    <Footer renderedYear={renderedYear} />
    <div aria-hidden="true" className="md:hidden bg-[#071426]" style={{ height: "calc(5rem + env(safe-area-inset-bottom))" }} />
    <MobileStickyBar />
    <QuoteModal />
  </div>
  );
};
